// extracted by mini-css-extract-plugin
export default {"Label":"Common_Label__Pzzor","Toggle":"Common_Toggle__CEFdv"};